export default __webpack_public_path__ + "static/media/media-auto-3.82b5af16.jpg";